import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import Icon from '../Icon';
import { NavLink } from 'react-router-dom';

class AdminTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hover: false,
			rowIndex: -1,
			btnIndex: -1,
			currentPage: 1
		};

		this.changePage = this.changePage.bind(this);
	}

	mouseOut(rowIndex, btnIndex) {
		this.setState({ hover: false, btnIndex, rowIndex });
	}

	mouseOver(rowIndex, btnIndex) {
		this.setState({ hover: true, btnIndex, rowIndex });
	}

	changePage(currentPage) {
		this.setState({ currentPage });
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.numberOfRows !== nextProps.numberOfRows) {
			this.setState({
				currentPage: 1
			});
		}
	}

	render() {
		const { hover, btnIndex, rowIndex, currentPage } = this.state;
		const {
			table,
			anonymous,
			showField,
			limit,
			hasPagination,
			numberOfRows,
			emptyMessage
		} = this.props;

		if (numberOfRows === 0) {
			return <span className="AdminTable-empty">{emptyMessage}</span>;
		}

		let currentRows = table.rows.slice(
			(currentPage - 1) * limit,
			currentPage * limit
		);

		const rowsCounter = table.rows.length;
		const numberOfPages = Math.ceil(rowsCounter / limit);

		const pages = [];

		for (let i = 0; i < numberOfPages; i++) {
			const page = {
				id: i + 1,
				active: currentPage === i + 1
			};

			pages.push(page);
		}

		let pagesTpl = null;

		if (numberOfPages <= 4) {
			pagesTpl = pages.map(page => {
				const pageClass = [
					'Pagination-page',
					page.active ? 'is-active' : ''
				].join(' ');

				return (
					<button
						key={page.id}
						className={pageClass}
						onClick={() => this.changePage(page.id)}
					>
						{page.id}
					</button>
				);
			});

			pagesTpl = <div className="Pagination-pages">{pagesTpl}</div>;
		} else {
			let firstPages = [];
			let middlePages = [];
			let lastPages = [];

			firstPages.push(pages[0], pages[1]);
			lastPages.push(pages[numberOfPages - 2], pages[numberOfPages - 1]);

			if (currentPage > firstPages.length && currentPage < numberOfPages - 1) {
				firstPages.splice(1, 1);
				middlePages.push(
					pages[currentPage - 2],
					pages[currentPage - 1],
					pages[currentPage]
				);
				lastPages.splice(0, 1);
			}

			//console.log(middlePages, lastPages);

			const firstPagesTpl = firstPages.map(page => {
				const pageClass = [
					'Pagination-page',
					page.active ? 'is-active' : ''
				].join(' ');

				return (
					<button
						key={page.id}
						className={pageClass}
						onClick={() => this.changePage(page.id)}
					>
						{page.id}
					</button>
				);
			});

			const middlePagesTpl = middlePages.map(page => {
				const pageClass = [
					'Pagination-page',
					page.active ? 'is-active' : ''
				].join(' ');

				return (
					<button
						key={page.id}
						className={pageClass}
						onClick={() => this.changePage(page.id)}
					>
						{page.id}
					</button>
				);
			});

			const lastPagesTpl = lastPages.map(page => {
				const pageClass = [
					'Pagination-page',
					page.active ? 'is-active' : ''
				].join(' ');

				return (
					<button
						key={page.id}
						className={pageClass}
						onClick={() => this.changePage(page.id)}
					>
						{page.id}
					</button>
				);
			});

			pagesTpl = (
				<div className="Pagination-pages">
					{firstPagesTpl}
					{(firstPages.length > 1 ||
						(middlePages.length > 0 && middlePages[0].id > 2)) && (
						<span className="Pagination-separator">...</span>
					)}
					{middlePagesTpl}
					{middlePages.length > 0 &&
						middlePages[2].id < numberOfPages - 1 && (
						<span className="Pagination-separator">...</span>
					)}
					{lastPagesTpl}
				</div>
			);
		}

		const paginationTpl = hasPagination &&
			currentRows.length > 0 && (
			<div className="Pagination">
				<button
					disabled={currentPage === 1}
					className="Pagination-previous"
					onClick={() => this.changePage(currentPage - 1)}
				>
					<Icon icon={'arrowDown'} />
					<span>Previous</span>
				</button>
				{pagesTpl}
				<button
					disabled={currentPage === numberOfPages}
					className="Pagination-next"
					onClick={() => this.changePage(currentPage + 1)}
				>
					<span>Next</span>
					<Icon icon={'arrowDown'} />
				</button>
			</div>
		);

		let rowColumnsStyles = [];

		const headTpl = table.columns.map((column, index) => {
			rowColumnsStyles.push(column.rowColumnStyles);

			return (
				<span
					className="AdminTable-column"
					key={index}
					style={{ ...column.styles }}
				>
					{column.label}
				</span>
			);
		});
		const rowsTpl = currentRows.map((row, index) => {
			return (
				<div key={index} className="AdminTable-row">
					{table.columns.map((column, ix) => {
						if (column.key === 'actions' && table.hasOwnProperty('actions')) {
							const actionsTpl = table.actions.map((action, actionIx) => {
								const {
									key,
									icon,
									tooltip,
									to,
									clicked,
									param,
									disabled = () => false
								} = action;

								const iconToShow = `${icon}${
									rowIndex === index &&
									hover &&
									actionIx === btnIndex &&
									icon !== 'trash'
										? 'Hover'
										: ''
								}`;

								const btn = to ? (
									<NavLink
										to={`${to}/${row[param]}`}
										className="AdminTable-iconButton"
									>
										<Icon icon={iconToShow} />
									</NavLink>
								) : (
									<button
										onClick={clicked}
										data-id={row[param]}
										className="AdminTable-iconButton"
									>
										<Icon icon={iconToShow} />
									</button>
								);

								return !disabled(row) ? (
									<div
										key={`${ix}-${actionIx}-${key}`}
										className="AdminTable-tooltipButton"
										onMouseOut={() => this.mouseOut(index, actionIx)}
										onMouseOver={() => this.mouseOver(index, actionIx)}
									>
										<span className="AdminTable-tooltip">{tooltip}</span>
										{btn}
									</div>
								) : null;
							});

							return (
								<span
									key={ix}
									className="AdminTable-column AdminTable-column--actions"
									style={rowColumnsStyles[ix]}
								>
									{actionsTpl}
								</span>
							);
						}
						const columnClass = [
							'AdminTable-column',
							table.columns[ix].hasOwnProperty('lock') && table.columns[ix].lock
								? 'AdminTable-column--lock'
								: ''
						].join(' ');

						const { key } = column;

						return (
							<span
								key={ix}
								className={columnClass}
								style={rowColumnsStyles[ix]}
							>
								{table.columns[ix].hasOwnProperty('prefixIcon') &&
									table.columns[ix].prefixIcon && (
									<span
										style={{ display: 'inline-block', margin: '0 5px 0 0' }}
									>
										<Icon icon={table.columns[ix].prefixIcon} />
									</span>
								)}
								{!table.columns[ix].hasOwnProperty('lock') && (
									<div>
										{anonymous &&
										anonymous.checked &&
										anonymous.hasOwnProperty('keys') &&
										anonymous.keys.indexOf(key) > -1 ? (
												`${key.toUpperCase()} ${index + 1}`
											) : /<("[^"]*"|'[^']*'|[^'">])*>/i.test(row[key]) ? (
												<div dangerouslySetInnerHTML={{ __html: row[key] }} />
											) : (
												row[key]
											)}
									</div>
								)}
								{table.columns[ix].hasOwnProperty('lock') &&
									table.columns[ix].lock && (
									<span style={{ display: 'flex', alignItems: 'center' }}>
										{table.columns[ix].rowIndexToUnlock ===
												index.toString() &&
											table.columns[ix].columnIndexToUnlock ===
												ix.toString() ? (
												<span style={{ width: '100px' }}>
													{String(row[column.key])}
												</span>
											) : (
												<span style={{ width: '100px' }}>***************</span>
											)}
										<button
											onClick={showField}
											data-field={table.columns[ix].key}
											data-row={index}
											data-column={ix}
											data-id={row.id}
											className="AdminTable-iconButton"
										>
											<Icon icon={'lock'} />
										</button>
									</span>
								)}
							</span>
						);
					})}
				</div>
			);
		});
		return (
			<div className="AdminTable">
				<div
					className="AdminTable-head"
					style={{
						backgroundColor: table.hasOwnProperty('columnsBackground')
							? table.columnsBackground
							: '#faebcd'
					}}
				>
					{headTpl}
				</div>
				<div className="AdminTable-body">{rowsTpl}</div>
				{paginationTpl}
			</div>
		);
	}
}

AdminTable.propTypes = {
	limit: PropTypes.number,
	table: PropTypes.object,
	anonymous: PropTypes.object,
	showField: PropTypes.func,
	hasPagination: PropTypes.bool,
	numberOfRows: PropTypes.number,
	emptyMessage: PropTypes.string
};

AdminTable.defaultProps = {
	hasPagination: true,
	limit: 5,
	emptyMessage: 'No records found'
};

export default AdminTable;
